export * from './Avatar'



// WEBPACK FOOTER //
// src/components/Avatar/index.ts